import { useEffect, useState } from "react";
import axios from "axios";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABEL = { suspend: "Suspended", restore: "Restored", set_plan: "Plan changed", cancel_stripe: "Stripe cancelled", impersonate: "Logged in as", delete: "Deleted", bulk_delete: "Bulk delete" };

export default function AuditDrawer({ open, onClose }) {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    if (!open) return;
    setEntries(null);
    axios.get(`${API}/platform/audit`).then((r) => setEntries(r.data.entries)).catch(() => setEntries([]));
  }, [open]);

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent className="w-[420px] sm:max-w-[420px] overflow-y-auto" data-testid="platform-audit-drawer">
        <SheetHeader><SheetTitle>Platform audit log</SheetTitle></SheetHeader>
        {entries === null ? <Loader2 className="w-5 h-5 animate-spin text-slate-400 mt-6" /> : entries.length === 0 ? (
          <p className="text-sm text-slate-500 italic mt-6">No platform actions yet.</p>
        ) : (
          <ul className="mt-4 space-y-3">
            {entries.map((e) => (
              <li key={e.id} className="text-sm border-l-2 border-teal-200 pl-3" data-testid={`audit-entry-${e.id}`}>
                <p className="font-medium text-slate-900">{LABEL[e.action] || e.action}{e.agency_name ? ` · ${e.agency_name}` : ""}</p>
                <p className="text-xs text-slate-500">{new Date(e.at).toLocaleString()} · {e.actor_email}</p>
                {e.details?.plan_id && <p className="text-xs text-slate-600">Plan → {e.details.plan_id}</p>}
                {e.details?.as_user && <p className="text-xs text-slate-600">as {e.details.as_user}</p>}
                {e.details?.count !== undefined && <p className="text-xs text-slate-600">{e.details.count} agencies: {(e.details.names || []).slice(0, 5).join(", ")}{(e.details.names || []).length > 5 ? "…" : ""}</p>}
              </li>
            ))}
          </ul>
        )}
      </SheetContent>
    </Sheet>
  );
}
